import React from 'react'

import IntegrationsEditor from '@/views/Integrations/IntegrationsEditor'
import { SecondaryNavRouter } from '@/components/layout/SecondaryNavRouter/SecondaryNavRouter'
import { PageHeader } from '@/components/headers/PageHeader'
import IntegrationsPlaybookSwitchingPage from '@/views/Integrations/IntegrationsPlaybookSwitchingPage'
import IntegrationsCallOutcomesPage from '@/views/Integrations/IntegrationsCallOutcomesPage'

export const EditPage = ({ tab }) => {
  const pages = [
    {
      label: 'Connector Config',
      component: <IntegrationsEditor />,
    },
    {
      label: '🚧 Call Outcomes 🚧',
      component: <IntegrationsCallOutcomesPage />,
    },
    {
      label: '🚧 Playbook Switching 🚧',
      component: <IntegrationsPlaybookSwitchingPage />,
    },
  ]

  return (
    <>
      <PageHeader title="Edit Integration" />

      <SecondaryNavRouter pages={pages} activePage={tab} />
    </>
  )
}

export default EditPage
